import { useMemo } from 'react'
import { Vector3 } from 'three'
import { useSceneElement } from '@editorHooks'
import Text3DThree from 'src/components/scene/Text3DThree'

const TEXT_X_ORIENTATION = new Vector3(1, 0, 0)
const TEXT_Y_ORIENTATION = new Vector3(0, 1, 0)
const EMPTY_MODEL_LABEL_POSITION = new Vector3(5, 5, 0)

const useEmptyModelSceneLabel = (enabled: boolean): void => {
  const textProperties = useMemo(
    () => ({
      textLines: ['leeres Modell'],
      color: 'black',
      backgroundColor: '#ffffff',
      borderColor: '#000000',
      borderWidth: 0.025,
      position: EMPTY_MODEL_LABEL_POSITION.clone(),
      scale: 0.25,
      textXOrientation: TEXT_X_ORIENTATION.clone(),
      textYOrientation: TEXT_Y_ORIENTATION.clone(),
      anchorLocation: 'center' as const,
      opacity: 1,
    }),
    [],
  )

  useSceneElement({
    enabled,
    component: Text3DThree,
    properties: textProperties,
  })
}

export default useEmptyModelSceneLabel
